import { render, staticRenderFns } from "./WootButton.vue?vue&type=template&id=7929e291&"
import script from "./WootButton.vue?vue&type=script&lang=js&"
export * from "./WootButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports